export default __webpack_public_path__ + "static/media/report-color-icon.68b314c8.svg";